import { tns } from "tiny-slider";

export const employeesSlider = () => {
    const employeesSliderContainer = document.getElementById('employee-slider');
    const employeesSliderControlsContainer = document.getElementById('employee-slider-controls');
    if (employeesSliderContainer && employeesSliderControlsContainer) {
        tns({
            container: employeesSliderContainer,
            startIndex: 0,
            controlsContainer: employeesSliderControlsContainer,
            "swipeAngle": false,
            autoWidth: false,
            nav: false,
            fixedWidth: 310,
            gutter: 16,
            loop: true,
            "speed": 400,
            slideBy: 1,
        })
    }
}
